import React from 'react'
import { Trans } from 'react-i18next'

import { Body2 } from '@ui/Typography'
import { Link } from '@ui/components/Link'

export const PaymentTermsConsent: React.FC<{ onOpen(): void }> = ({ onOpen }) => (
  <Body2>
    <Trans
      i18nKey='Payment Terms.Implicit consent'
      components={{
        termsConditions: (
          <Link
            size='md'
            variant='tertiary'
            onClick={(event) => {
              event.preventDefault()
              onOpen()
            }}
          />
        ),
      }}
    />
  </Body2>
)
